export default __webpack_public_path__ + "static/media/funnel-view.db2e3586.png";